import _ from 'lodash';

export default function fieldValue(row, field) {
  return _.get(row, field.path ?? field.key);
}
